import { render, staticRenderFns } from "./InfoDetailsWalone.vue?vue&type=template&id=2caeca83&scoped=true"
import script from "./InfoDetailsWalone.vue?vue&type=script&lang=js"
export * from "./InfoDetailsWalone.vue?vue&type=script&lang=js"
import style0 from "./InfoDetailsWalone.vue?vue&type=style&index=0&id=2caeca83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caeca83",
  null
  
)

export default component.exports